<template>
  <div>
    <el-form
      ref="certificationForm"
      label-width="150px"
      label-suffix="："
      size="small"
      :class="{ 'disabled-item-form': disabled }"
      :model="formData"
      :rules="formRules"
    >
      <div class="section">
        <base-section-title title="填写主体信息" class="section-title" />
        <div class="section-content">
          <div class="form-style">
            <el-form-item label="名称" prop="companyName">
              <el-input
                v-model="formData.companyName"
                placeholder="请输入"
                @blur="formData.companyName = $event.target.value.trim()"
              />
              <div class="disabled-form-item">{{ formData.companyName }}</div>
            </el-form-item>

            <el-form-item label="统一社会信用代码" prop="socialCreditCode">
              <el-input
                v-model="formData.socialCreditCode"
                placeholder="请输入"
              />
              <div class="disabled-form-item">
                {{ formData.socialCreditCode }}
              </div>
            </el-form-item>

            <el-form-item label="经营者" prop="legalPersonInfo.legalPersonName">
              <el-input
                v-model="formData.legalPersonInfo.legalPersonName"
                placeholder="请输入"
                @blur="
                  formData.legalPersonInfo.legalPersonName = $event.target.value.trim()
                "
              />
              <div class="disabled-form-item">
                {{ formData.legalPersonInfo.legalPersonName }}
              </div>
            </el-form-item>

            <el-form-item label="经营场所(地区)" prop="regionInfo.region">
              <base-area-select :show-country="true" :address.sync="address" />
              <div class="disabled-form-item">
                {{
                  `${address.country} ${address.province}${address.city &&
                    '/'}${address.city}${address.county && '/'}${
                    address.county
                  }`
                }}
              </div>
            </el-form-item>

            <el-form-item label="经营场所(地址)" prop="regionInfo.address">
              <el-input
                v-model="formData.regionInfo.address"
                placeholder="请输入"
                @blur="formData.regionInfo.address = $event.target.value.trim()"
              />
              <div class="disabled-form-item">
                {{ formData.regionInfo.address }}
              </div>
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="section">
        <base-section-title title="管理员" class="section-title" />
        <div class="section-content">
          <div class="form-style">
            <el-form-item label="管理员姓名" prop="contactInfo.contactName">
              <el-input
                v-model="formData.administratorInfo.name"
                placeholder="请输入"
                @blur="
                  formData.administratorInfo.name = $event.target.value.trim()
                "
              />
              <div class="disabled-form-item">
                {{ formData.administratorInfo.name }}
              </div>
            </el-form-item>

            <el-form-item label="管理员电话号码">
              <el-input
                v-model="userMobile"
                placeholder="请输入"
                :disabled="true"
              />
              <div class="disabled-form-item">
                {{ userMobile }}
              </div>
            </el-form-item>

            <el-form-item label="管理员邮箱">
              <el-input
                v-model="formData.administratorInfo.email"
                placeholder="请输入"
              />
              <div class="disabled-form-item">
                {{ formData.administratorInfo.email }}
              </div>
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="section">
        <base-section-title title="填写联系人信息" class="section-title" />
        <div class="section-content">
          <div class="form-style">
            <el-form-item label="联系人姓名" prop="contactInfo.contactName">
              <el-input
                v-model="formData.contactInfo.contactName"
                placeholder="请输入"
                @blur="
                  formData.contactInfo.contactName = $event.target.value.trim()
                "
              />
              <div class="disabled-form-item">
                {{ formData.contactInfo.contactName }}
              </div>
            </el-form-item>

            <el-form-item label="联系人电话号码" prop="contactInfo.contactTel">
              <el-input
                v-model="formData.contactInfo.contactTel"
                placeholder="请输入"
              />
              <div class="disabled-form-item">
                {{ formData.contactInfo.contactTel }}
              </div>
            </el-form-item>

            <el-form-item label="联系人邮箱" prop="contactInfo.contactEmail">
              <el-input
                v-model="formData.contactInfo.contactEmail"
                placeholder="请输入"
              />
              <div class="disabled-form-item">
                {{ formData.contactInfo.contactEmail }}
              </div>
            </el-form-item>
          </div>
        </div>
      </div>

      <div class="section">
        <base-section-title title="上传主体证件" class="section-title" />
        <div class="section-content">
          <div class="form-style">
            <el-form-item label-width="0" prop="photoInfo.businessLicense">
              <credential-item
                v-model="formData.photoInfo.businessLicense"
                upload-title="多证合一营业执照，照片或扫描件，复印件需加盖公司红色公章"
                sample-picture-url="/resources/certification/business-licence.jpg"
                :disabled="disabled"
              >
                <template v-slot:uploadDesc>
                  <p>信息需清晰可见，内容真实有效，不得做任何修改</p>
                  <p>支持JPG、JPEG、PNG、BMP格式，大小不超过5M</p>
                </template>
              </credential-item>
            </el-form-item>

            <el-form-item label-width="0" prop="photoInfo.idCardReverse">
              <credential-item
                v-model="formData.photoInfo.idCardReverse"
                upload-title="经营者身份证国徽面"
                sample-picture-url="/resources/certification/id-card-background.png"
                :disabled="disabled"
              >
                <template v-slot:uploadDesc>
                  <p>
                    需上传照片或扫描件，信息需清晰可见，内容真实有效，不得做任何修改
                  </p>
                  <p>支持JPG、JPEG、PNG、BMP格式，大小不超过5M</p>
                </template>
              </credential-item>
            </el-form-item>

            <el-form-item label-width="0" prop="photoInfo.idCardFront">
              <credential-item
                v-model="formData.photoInfo.idCardFront"
                upload-title="经营者身份证人像面"
                sample-picture-url="/resources/certification/id-card-front.png"
                :disabled="disabled"
              >
                <template v-slot:uploadDesc>
                  <p>
                    需上传照片或扫描件，信息需清晰可见，内容真实有效，不得做任何修改
                  </p>
                  <p>支持JPG、JPEG、PNG、BMP格式，大小不超过5M</p>
                </template>
              </credential-item>
            </el-form-item>

            <el-form-item label-width="0" prop="photoInfo.idCardHandHeld">
              <credential-item
                v-model="formData.photoInfo.idCardHandHeld"
                upload-title="经营者身份证手持证"
                sample-picture-url="/resources/certification/id-card-photo.png"
                :disabled="disabled"
              >
                <template v-slot:uploadDesc>
                  <p>
                    需上传照片或扫描件，信息需清晰可见，内容真实有效，不得做任何修改
                  </p>
                  <p>支持JPG、JPEG、PNG、BMP格式，大小不超过5M</p>
                </template>
              </credential-item>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/BaseSectionTitle'
import BaseAreaSelect from '@/components/BaseAreaSelect'
import CredentialItem from '@/views/enterprise-cert/component/CredentialItem'

// mixins
import formDataMixin from '@/views/enterprise-cert/component/form.js'

// 数据字典
import { companyNatureDict } from '@/dictionary/company'

export default {
  name: 'SelfEmployedForm',

  components: {
    BaseSectionTitle,
    BaseAreaSelect,
    CredentialItem
  },

  mixins: [formDataMixin],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 数据字典
      companyNatureDict
    }
  },

  methods: {}
}
</script>

<style scoped lang="scss"></style>
